<template>
    <div id="contactusDiv">
        <HeaderVue isHeader="true"/>
        <div class="container-fluid static-content">
            <div class="row">
                <div class="col-12">
                    <h3>Contact us / Feedback</h3>
                    <div class="form-content line-textbox">
                      <form data-vv-scope="contact">
                        <div class="form-group">
                            <input class="form-control" type="text" name="name" data-vv-as="name" v-model="name" v-validate="'required|alpha_spaces|max:75'" placeholder="Name">
                            <span v-show="errors.has('contact.name')" class="text-danger">{{ errors.first('contact.name') }}</span>
                        </div>
                        <div class="form-group">
                              <input class="form-control" type="email" v-model="email" data-vv-as="email address" name="email" v-validate="'required|email|max:100'" placeholder="Email Address">
                              <span v-show="errors.has('contact.email')" class="text-danger">{{ errors.first('contact.email') }}</span>
                        </div>
                        <div class="form-group">
                            <input class="form-control" type="text" name="mobile" v-model="mobile" data-vv-as="mobile no." v-validate="'required|numeric|max:10|min:10'" placeholder="Mobile No.">
                            <span v-show="errors.has('contact.mobile')" class="text-danger">{{ errors.first('contact.mobile') }}</span>
                        </div>
                        <div class="form-group">
                            <textarea class="form-control" name="message" v-model="message" data-vv-as="message" v-validate="'required|max:2000'"  cols="30" rows="3" placeholder="Message" ></textarea>
                            <span v-show="errors.has('contact.message')" class="text-danger">{{ errors.first('contact.message') }}</span>
                            <!-- <textarea class="form-control" placeholder="Message" name="" id="" cols="30" rows="3"></textarea> -->
                        </div>
                        <div class="row">
                            <div class="col-5">
                                <button class="btn btn-link full-width" @click.prevent="reset()">Reset</button>
                            </div>
                            <div class="col-7">
                                <button class="btn btn-primary fly-msg full-width" @click.prevent="save()" :disabled="(errors.any())">Save</button>
                            </div>
                        </div>
                      </form>
                    </div>
                </div>
            </div>
            <!-- <div class="row mt-4 mb-4">
                <div class="col-12">
                    <div class="p-3 rounded gray-bg-1">
                        <div class="get-in-touch">
                            <h5>Get in touch</h5>
                            <p>
                                <b>Labotist Private Limited</b>
                            </p>
                            <address>
                                <b>Chennai : </b>
                                <br> Flat No 8, 2nd Floor,
                                <br> Old No 4, New No 5,
                                <br> Rajachar Street,
                                <br> T.Nagar, Chennai,
                                <br> TamilNadu 600017,
                                <br> India.
                            </address>
                            <address>
                                <b>Bengaluru : </b>
                                <br> Suite No: 27, ONE Co-Work,
                                <br> Level 2, Sony World Junction,
                                <br> 80 Ft Rd,
                                <br> Koramangala, Bengaluru,
                                <br> Karnataka 560034,
                                <br> India.
                            </address>
                            <p>Ph:<a href="tel:+919025662566"> +91 90256 62566</a></p>
                            <p>email: <a href="mailto:support@labotist.com" target="_top">support@labotist.com</a></p>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
        <div class="contact-info" style="padding-left:13%">
            <div class="container">
                <ul class="row text-center">
                    <li>
                        <span class="sprites sprite-mail align-center"></span>
                        <p><a href="mailto:support@labotist.com" target="_top"> support@labotist.com </a></p>
                    </li>
                    <li>
                        <span class="sprites sprite-call align-center"></span>
                        <p><a href="tel:+919025662566">+91 90256 62566</a></p>
                    </li>
                </ul>
            </div>
        </div>
        <FooterVue foot="true"/>
    </div>
</template>

<script>
import HeaderVue from '@/components/mobile/Header'
import FooterVue from '@/components/mobile/Footer'
import Sidemenu from '@/components/mobile/Public/Sidemenu'

export default {
  name: 'Contactus',
  components: {
    HeaderVue,
    FooterVue,
    Sidemenu
  },
  beforeCreate () { },
  data () {
    return {
      name: '',
      email: '',
      mobile: '',
      message: '',
      success: false
    }
  },
  methods: {
    save: function () {
      this.$validator.validateAll('contact').then(function (result) {
        if (result) {
          try {
            if (this.name !== '' && this.email !== '' && this.mobile !== '' && this.message !== '') {
              let data = {
                'name': this.name,
                'email': this.email,
                'mobile': this.mobile,
                'message': this.message
              }
              Promise.resolve(this.$POST('patient/contact', data)).then(function (res) {
                if (res.response_code === 0) {
                  this.success = true
                //   location.reload()
                  this.$Simplert.open({
                    title: 'Success',
                    message: `Thanks for contact us. We will touch with you soon.`,
                    type: 'warning',
                    disableOverlayClick: true,
                    showXclose: true,
                    useConfirmBtn: false,
                    customCloseBtnText: 'OK'
                  })
                  this.reset()
                }
              }.bind(this)).catch(function (err) {
                console.error(err)
                this.$Simplert.open({
                  title: 'Oops',
                  message: `Something went wrong please mail us support@labotist.com`,
                  type: 'warning',
                  disableOverlayClick: true,
                  showXclose: true,
                  useConfirmBtn: false,
                  customCloseBtnText: 'OK'
                })
                // alert('Something went wrong please mail us support@labotist.com')
              }.bind(this))
            }
          } catch (e) {
            console.error(e)
          }
        }
      }.bind(this))
    },
    reset: function () {
      this.errors.items = []
      this.name = ''
      this.email = ''
      this.mobile = ''
      this.message = ''
      this.success = false
      setTimeout(function () {
        this.errors.items = []
      }.bind(this), 30)
    }
  },
  mounted () {
    this.$hidePageLoading()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/mobile/Public/Contactus.vue